import BaseService from "./base.service";

class DisciplinaryCategoryService extends BaseService {
  constructor() {
    super("disciplinary-category");
  }
}

export default new DisciplinaryCategoryService();
